import React from 'react';

import './MediaPageSkeleton.scss';

const MediaPageSkeletonItem = () => (
  <div className="gridItem skeleton-item">
    <div className="skeleton-trigger">
      <div className="imgContainer">
        <div className="skeleton-image" />
        <div className="skeleton-title" />
      </div>
    </div>
  </div>
);

const MediaPageSkeleton = () => (
  <div className="gridContainer">
    {[...Array( 6 )].map( ( _, index ) => (
      <MediaPageSkeletonItem key={`skeleton-${index}`} />
    ) )}
  </div>
);

export default MediaPageSkeleton;
